import React, { useState, useEffect } from 'react'
import { Modal, Form, Col } from "react-bootstrap";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import useAuth from "hooks/useAuth"
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api";


function ModalBoundSell(props) {

    const [br, setBR] = useState(false);
    const [nf, setNf] = useState();
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    async function handleBound() {
        const response = await api.put('/order/bound    ing/with/sell/' + props.props.id, {
            nf
        })
        if (response.data.error) {
            return alert(response.data.error);
        }
        setControlSnack(true);
        props.onHide();
    }

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };
    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Vincular venda ao pedido
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleBound}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridNf">
                            <Form.Label>Nota fiscal</Form.Label>
                            <Form.Control onChange={event => setNf(event.target.value)} type="number" placeholder="Nota fiscal em que o pedido foi vinculado" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>

                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Vincular
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Pedido vinculado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    )

}

export default ModalBoundSell;